import {fetch} from '../../helper/http';

export default {
  //template: '',
  props:['scope','url','method','data','state','closeAuto','assign'],
  beforeMount:function(){
    vm.$watch(this.data,{
      deep: true,
      immediate: true,
      handler:this.fetchData
    });
  },

  methods:{
    fetchData:function(){
      if(this.closeAuto) return;   //关闭自动功能
      const data = vm[this.data];
      fetch(this.method,this.url,data)
      .then(({code,data})=>{
        if(code !=200) return;
        //挂载到全局
        const target = this.scope?window[this.scope]:vm;
        if(this.assign){  // 合并
          target[this.state] = $.extend(true,target[this.state],data);
        }else{
          target[this.state] = data; //直接覆盖
        }
      });
    }
  },

  render:function(){
    return null;
  }
};


// WEBPACK FOOTER //
// ./src/components/request/index.js